export default {
  OPERATING_MODE_ID: 'cfo.operation_mode.id',
  CFO_TABLE_FIELDS: 'cfo_table_fields',
  AGENT_STORAGE_KEY: '_ag:s:data',
  SESSION_ID_KEY: '_ag:s:k'
}
